<template>
  <div>
    <v-data-table
      id="style-2"
      :headers="tableHeaders"
      :footer-props="tableFooter"
      :expanded.sync="expanded"
      :hide-default-footer="true"
      item-key="lessonId"
      :show-expand="!isSelfStudy ? showExpand : false"
      single-expand
      :items="homeworks.data"
      disable-sort
      class="homework-table"
      :class="isSelfStudy ? 'self-study' : ''"
      fixed-header
      :height="height"
      no-data-text="Không có dữ liệu bản ghi"
      loading-text="Đang tải dữ liệu...."
      :loading="isLoading"
      :items-per-page="20"
    >
      <template v-slot:top="{pagination, options, updateOptions}">
        <v-data-footer
          v-if="!isPreview"
          class="custom-homework-footer"
          :pagination="pagination"
          :options="options"
          next-icon="mdi-menu-right"
          prev-icon="mdi-menu-left"
          @update:options="updateOptions"
          items-per-page-text="">
          <template v-slot:page-text="{pageStart, pageStop}">
            {{pageStart }} - {{ pageStop }}
          </template>
        </v-data-footer>
      </template>
      <template v-slot:header.data-table-expand>
        <div
          style="height: 100%; width: 100%; position: absolute; top: 0; left: 0; box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.12);"
          :style="isBlended ? 'background: #FBD9E9' : ''"
          v-if="!isSelfStudy"
        >
        </div>
      </template>
      <template v-slot:header.timeDoHomework>
        <div class="d-flex align-center">
          Thời gian làm bài
          <v-tooltip top>
            <template v-slot:activator="{attrs, on}">
              <v-icon v-on="on" v-bind="attrs" :color="isBlended ? 'grey' : 'white'" style="font-size: 16px; margin-left: 4px">mdi-information-outline</v-icon>
            </template>
            <div>
              Tính theo thời gian học sinh nộp bài
            </div>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:header.date>
        <div class="d-flex align-center">
          Ngày học
          <v-tooltip top>
            <template v-slot:activator="{attrs, on}">
              <v-icon v-on="on" v-bind="attrs" :color="isBlended ? 'grey' : 'white'" style="font-size: 16px; margin-left: 4px">mdi-information-outline</v-icon>
            </template>
            <div>
              Là thời gian học sinh có tương tác với bài học qua làm bài tập/ xem video/ xem tài liệu
            </div>
          </v-tooltip>
          <date-picker
            v-if="$route.query.tutorSchoolLevel === 'secondary'"
            format="YYYY-MM"
            class="custome-date-2 mx-2"
            value-type='format'
            v-model="dataDateSelect"
            type="month"
            :clearable="false"
            :lang="lang"
            :disabled-date="disabledAfterToday"
            @change="setDateFilter"
          >
            <template #icon-calendar>
              <v-icon>mdi-menu-down</v-icon>
            </template>
          </date-picker>
        </div>
      </template>
      <template v-slot:header.lessonTitle>
        <div class="d-flex align-center">
          Buổi học
          <date-picker
            v-if="$route.query.tutorSchoolLevel === 'secondary'"
            format="YYYY-MM"
            class="custome-date-2 mx-2"
            value-type='format'
            v-model="dataDateSelect"
            type="month"
            :clearable="false"
            :lang="lang"
            :disabled-date="disabledAfterToday"
            @change="setDateFilter"
          >
            <template #icon-calendar>
              <v-icon>mdi-menu-down</v-icon>
            </template>
          </date-picker>
        </div>
      </template>
      <template #item.data-table-expand="{ item, expand, isExpanded }">
        <td class="text-start" :class="isBlended ? 'blended' : ''">
          <v-btn
            v-if="item.practices && item.practices.length > 0"
            icon
            @click="expand(!isExpanded)"
            class="v-data-table__expand-icon"
            :class="{'v-data-table__expand-icon--active' : isExpanded}">
              <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:footer.page-text="{pageStart, pageStop}">
        {{pageStart }} - {{ pageStop }}
      </template>
      <template v-slot:item.date="{item}">
        <div style="padding-left: 12px">
          {{formatDateCus(item.lessonTime, 'DD/MM/YYYY HH:mm')}}
        </div>
      </template>
      <template v-slot:item.name="{item}">
        <div>
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{item.name}}</span>
              </template>
              <span>{{item.courseName}} - {{item.categoryName}}</span>
            </v-tooltip>
            <div
              class="skill-tag"
              :style="`background: ${getSkillTagColor(item.skill).color}; color: ${getSkillTagColor(item.skill).textColor}`"
            >{{item.skill}}</div>
          </div>
        </div>
      </template>
      <template v-slot:item.comment="{item}">
        <div v-if="!item.comment" class="d-flex align-center" style="height: 100%">
          <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
        </div>
        <div v-if="item.comment && item.comment.length">
          <div class="text-teacher">Giáo viên: {{item.teacherCode}} - {{item.teacherName}}</div>
          <note-teacher :textNote="item.comment"/>
          <!-- <div v-for="(cmt,index) in item.comment" :key="'cmt'+ index">
            <span class="text-comment">{{cmt}}</span>
          </div> -->
        </div>
      </template>
      <template v-slot:item.action="{item}">
        <div class="d-flex justify-center" v-if="(isTutorHomeroomTeacherSecondary && $route.query.schoolLevel === 'secondary') && checkAuthorization('tutor-homeroom-teacher-secondary_read')">
          <div>
              <v-tooltip bottom v-if="item.comment && item.comment.length" >
                <template v-slot:activator="{ on }">
                  <span v-on="on" color="#E91E63" @click="EditAction(item)" style="cursor: pointer;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M4.75583 14.4105L12.5 6.66631L8.82167 2.98798L1.0775 10.7321C0.970887 10.8389 0.895153 10.9725 0.858334 11.1188L0 15.488L4.36833 14.6296C4.515 14.593 4.64917 14.5171 4.75583 14.4105ZM15 4.16631C15.3125 3.85377 15.488 3.42992 15.488 2.98798C15.488 2.54604 15.3125 2.12219 15 1.80964L13.6783 0.487978C13.3658 0.175526 12.9419 0 12.5 0C12.0581 0 11.6342 0.175526 11.3217 0.487978L10 1.80964L13.6783 5.48798L15 4.16631Z" fill="#E91E63"/>
                    </svg>
                  </span>
                </template>
                <span>Chỉnh sửa nhận xét</span>
              </v-tooltip>
          </div>
          <div>
              <span v-if="item.publishStatus" class="mx-2" >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.33366 7.08496C0.33366 3.22949 3.45085 0.0849609 7.33366 0.0849609C11.1891 0.0849609 14.3337 3.22949 14.3337 7.08496C14.3337 10.9678 11.1891 14.085 7.33366 14.085C3.45085 14.085 0.33366 10.9678 0.33366 7.08496ZM10.4782 5.88184C10.779 5.58105 10.779 5.11621 10.4782 4.81543C10.1774 4.51465 9.71257 4.51465 9.41179 4.81543L6.45866 7.76855L5.22819 6.56543C4.92741 6.26465 4.46257 6.26465 4.16179 6.56543C3.861 6.86621 3.861 7.33105 4.16179 7.63184L5.91179 9.38184C6.21257 9.68262 6.67741 9.68262 6.97819 9.38184L10.4782 5.88184Z"
                    fill="#4CAF50"
                  />
                </svg>
              </span>
              <v-tooltip bottom v-if="!item.publishStatus && item.comment && item.comment.length" >
                <template v-slot:activator="{ on }">
                  <span v-on="on" color="#E91E63"  @click="publishShareAction(item)" style="cursor: pointer;" class="mx-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <path d="M14.7976 5.77734L10.7067 10.2773C10.5788 10.4258 10.419 10.5 10.2273 10.5C10.142 10.5 10.0533 10.4805 9.96094 10.4414C9.68395 10.3086 9.54545 10.0781 9.54545 9.75V7.5H7.84091C5.54688 7.5 3.99148 8.01172 3.17472 9.03516C2.32955 10.1055 2.06676 11.9531 2.38636 14.5781C2.40767 14.7578 2.33665 14.8906 2.1733 14.9766C2.11648 14.9922 2.07386 15 2.04545 15C1.93182 15 1.83949 14.9492 1.76847 14.8477C1.69744 14.7383 1.62287 14.6172 1.54474 14.4844C1.46662 14.3516 1.32635 14.084 1.12393 13.6816C0.92152 13.2793 0.745739 12.8906 0.596591 12.5156C0.447443 12.1406 0.310725 11.6953 0.186435 11.1797C0.062145 10.6641 0 10.1875 0 9.75C0 9.36719 0.012429 9.01172 0.0372869 8.68359C0.0621449 8.35547 0.111861 8.00391 0.186435 7.62891C0.261009 7.25391 0.36044 6.91016 0.48473 6.59766C0.60902 6.28516 0.775923 5.9668 0.98544 5.64258C1.19496 5.31836 1.43821 5.0293 1.7152 4.77539C1.99219 4.52148 2.32777 4.28125 2.72195 4.05469C3.11612 3.82812 3.55824 3.63867 4.0483 3.48633C4.53835 3.33398 5.10476 3.21484 5.74751 3.12891C6.39027 3.04297 7.08807 3 7.84091 3H9.54545V0.75C9.54545 0.421875 9.68395 0.191406 9.96094 0.0585938C10.0533 0.0195313 10.142 0 10.2273 0C10.4119 0 10.5717 0.0742188 10.7067 0.222656L14.7976 4.72266C14.9325 4.87109 15 5.04688 15 5.25C15 5.45312 14.9325 5.62891 14.7976 5.77734Z" fill="#E91E63"/>
                    </svg>
                  </span>
                </template>
                <span>Chia sẻ nhận xét</span>
              </v-tooltip>
          </div>
        </div>
      </template>
      <template v-slot:item.timeDate="{item}">
        {{item.classTitle}}
        <br>
        {{formatDateCus(item.lessonStartTime, 'DD/MM/YYYY')}}
        <br>
        {{formatDateCus(item.lessonStartTime, 'HH:mm') + ' - ' + formatDateCus(item.lessonEndTime, 'HH:mm')}}
        <br>
        <div
          class="skill-tag"
          :style="`background: ${getTypeTagColor(item.type).color}; color: ${getTypeTagColor(item.type).textColor}`"
        >{{item.type}}</div>
      </template>
      <template v-slot:item.curriculum="{item}">
        {{item.curriculumId && mapProgramIdAndProgram[item.curriculumId] ? mapProgramIdAndProgram[item.curriculumId].title : (item.courseName ? item.courseName : '')}}
      </template>
      <template v-slot:item.exercise="{item}">
        <div style="width: fit-content" v-if="item.homeworks && item.homeworks.length > 0">
          <div style="font-size: 13px !important;" class="d-flex align-center" v-if="item.homeworks.length > 1">
            <div :style="{color: isSelfStudy ? '' : '#0088FF', cursor: isSelfStudy ? '' : 'pointer', fontWeight: isSelfStudy ? 'bold' : ''}" @click="isSelfStudy ? '' : handleRedirectCareHomework(item.lessonStartTime, item)">
              {{item.homeworks.length}} Bài tập
            </div>
            <v-icon style="font-size: 15px; margin-left: 6px" :color="checkHomeworksStatus(item.homeworks)">mdi-check-circle</v-icon>
          </div>
          <div style=" margin-bottom: 7px"></div>
          <div v-for="(homework, index) in item.homeworks.slice(0,3)" :key="'exercise' + index" class="d-flex align-center">
            <div :style="{color: isSelfStudy ? '' : '#0088FF', cursor: isSelfStudy ? '' : 'pointer'}" v-if="item.homeworks.length === 1" @click="isSelfStudy ? '' : handleRedirectCareHomework(item.lessonStartTime, item)">
              {{homework.name}}
            </div>
            <div v-else>
              {{homework.name}}
            </div>
            <span style="font-size: 14px !important; color: #0088FF; margin-left: 10px" v-if="homework.correctQuestions !== null">
              <v-tooltip top>
                <template v-slot:activator="{attrs, on}">
                  <a v-on="on" v-bind="attrs" :href="homework.linkResult" style="text-decoration: none" target="_blank" v-if="!isSelfStudy">
                    {{homework.correctQuestions}}/{{homework.totalQuestions}}
                  </a>
                  <div v-else v-on="on" v-bind="attrs" @click="handleRedirectHomeworkDetail(homework)">
                    <a v-if="homework.gradingScale === 0">
                      {{homework.correctQuestions}}/{{homework.totalQuestions}}
                    </a>
                    <a v-else-if="homework.gradingScale === 1">
                      {{homework.bandScore}}
                    </a>
                    <a v-else-if="homework.gradingScale === 2">
                      {{homework.hundredScore}}/100
                    </a>
                    <a v-else-if="homework.gradingScale === 4">
                      {{parseFloat(homework.correctQuestions/homework.totalQuestions).toFixed(2)}}
                    </a>
                  </div>
                </template>
                <div v-if="!isSelfStudy">Số câu đúng/ Tổng số câu</div>
                <div v-else>
                  Làm bài (Thời gian nộp bài) : {{formatDateCus(homework.time, 'DD/MM/YYYY HH:mm')}}
                  <br>
                  {{GRADING_SCALE[homework.gradingScale]}}
                </div>
              </v-tooltip>
            </span>
            <a v-else @click="isSelfStudy ? handleRedirectHomeworkDetail(homework) : ''" style="color: #EB5501; font-weight: bold; margin-left: 10px; text-decoration: none" :href="homework.linkPractice" target="_blank">
              {{homework.status}}
            </a>
          </div>
          <div v-if="item.homeworks.length > 3" class="d-flex justify-center">
            <v-tooltip top>
              <template v-slot:activator="{ attrs, on}">
                <img v-if="!isSelfStudy" v-on="on" v-bind="attrs" src="../../../modules/student_detail_bt/assets/more-icon.svg" @click="handleShowMoreHomeworks(item.homeworks, item.lessonTitle)" alt="" style="cursor: pointer">
                <img v-else v-on="on" v-bind="attrs" src="../../../modules/student_detail_bt/assets/more-icon.svg" @click="handleShowMoreHomeworks(item.homeworks, item.name, true)" alt="" style="cursor: pointer">
              </template>
              <div>Xem thêm bài tập</div>
            </v-tooltip>
          </div>
        </div>
        <div v-else class="d-flex align-center" style="height: 100%">
          <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
        </div>
      </template>
      <template v-slot:item.timeDoHomework="{headers, item}">
        <div class="d-flex flex-column justify-start" v-if="item.homeworks && item.homeworks.length > 0">
          <div style="font-size: 13px !important; visibility: hidden" v-if="item.homeworks.length > 1">
            {{item.homeworks.length}} Bài tập
          </div>
          <div style=" margin-bottom: 7px"></div>
          <div v-for="(homework, index) in item.homeworks.slice(0,3)" :key="'exercise' + index">
            <div style="font-size: 14px !important;" v-if="homework.time">{{formatDateCus(homework.time, 'DD/MM/YYYY HH:mm')}}</div>
            <img v-else src="../../../modules/student_care/assets/empty-data.svg" alt="">
          </div>
        </div>
        <div v-else class="d-flex align-center" style="height: 100%">
          <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
        </div>
      </template>
      <template v-slot:item.videos="{headers, item}">
        <div v-if="item.linkVideos && item.linkVideos.length > 0">
          <div
            v-for="(video, index) in item.linkVideos"
            :key="'status' + index"
          >
          <a
              v-if="video.link"
             :href="video.link"
             target="_blank"
             style="text-decoration: none !important;"
          >
            <v-icon v-if="video.status" :color="VIDEO_STATUS_COLOR[video.status]">
              mdi-video
            </v-icon>
            <v-tooltip top v-if="video.time">
              <template v-slot:activator="{ attrs, on }">
                <div v-bind="attrs" v-on="on" class="ml-1">
                  Video {{index + 1}}
                </div>
              </template>
              <div>
                Xem video: {{formatDateCus(video.time, 'DD/MM/YYYY')}}
              </div>
            </v-tooltip>
            <div v-else>Video {{index + 1}}</div>
            <br>
          </a>
          <div class="d-flex align-center" v-else>
            <v-icon v-if="video.status" :color="VIDEO_STATUS_COLOR[video.status]">
              mdi-video
            </v-icon>
            <v-tooltip top v-if="video.time">
              <template v-slot:activator="{ attrs, on }">
                <div v-bind="attrs" v-on="on" class="ml-1">
                  Video {{index + 1}}
                </div>
              </template>
              <div>
                Xem video: {{formatDateCus(video.time, 'DD/MM/YYYY')}}
              </div>
            </v-tooltip>
            <div v-else>Video {{index + 1}}</div>
            <br>
          </div>
        </div>
        </div>
        <div v-else class="d-flex align-center" style="height: 100%">
          <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
        </div>
      </template>
      <template v-slot:item.documents="{headers, item}">
        <div v-if="item.documents && item.documents.length > 0">
          <a v-for="(document, index) in item.documents"
             :key="'status' + index"
             class="d-flex align-center"
             target="_blank"
             :href="document.link"
             style="text-decoration: none !important;"
          >
            <v-icon style="transform: rotate(45deg)">
              mdi-paperclip
            </v-icon>
            <div style="color: #0088FF">
              Tài liệu {{index + 1}}
            </div>
            <br>
          </a>
        </div>
        <div v-else class="d-flex align-center" style="height: 100%">
          <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
        </div>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="padding: 0 !important;">
          <v-simple-table class="inner-homework-table">
            <template v-slot:default>
              <tbody>
                <tr v-for="(practice, index) in item.practices" :key="'lesson' + index">
                  <td style="min-width: 49px; width: 49px"></td>
                  <td style="width: 250px; min-width: 250px">
                    <div style="padding-left: 12px">
                      {{practice.name}}
                      <div
                        class="skill-tag"
                        :style="`background: ${getSkillTagColor(practice.skill).color}; color: ${getSkillTagColor(practice.skill).textColor}`"
                      >{{practice.skill}}</div>
                    </div>
                  </td>
                  <td style="width: 150px; min-width: 150px">
                    <div
                      class="skill-tag"
                      :style="`background: ${getTypeTagColor(practice.type).color}; color: ${getTypeTagColor(practice.type).textColor}`"
                    >{{practice.type}}</div>
                  </td>
                  <td style="width: 230px; min-width: 230px">
                    <div v-if="practice.homeworks && practice.homeworks.length > 0" style="width: fit-content">
                      <div style="font-size: 13px !important; margin-bottom: 6px;" class="d-flex align-center" v-if="practice.homeworks.length > 1">
                        <div @click="handleRedirectCareHomework(item.lessonStartTime, item)" style="cursor: pointer; color: #0088FF">
                          {{practice.homeworks.length}} Bài tập
                        </div>
                        <v-icon style="font-size: 15px; margin-left: 6px" :color="checkHomeworksStatus(practice.homeworks)">mdi-check-circle</v-icon>
                      </div>
                      <div v-for="(homework, index) in practice.homeworks.slice(0, 3)" :key="'exercise' + index" class="d-flex align-center">
                        <div v-if="practice.homeworks.length === 1" @click="handleRedirectCareHomework(item.lessonStartTime, item)" style="cursor: pointer; color: #0088FF">
                          {{homework.name}}
                        </div>
                        <div v-else>
                          {{homework.name}}
                        </div>
                        <div style="font-size: 14px !important; color: #0088FF; margin-left: 10px" v-if="homework.totalCorrectQuestions !== null">
                          <v-tooltip top>
                          <template v-slot:activator="{attrs, on}">
                            <div v-on="on" v-bind="attrs" @click="handleRedirectHomeworkDetail(homework)" style="cursor: pointer">
                              <a v-if="homework.gradingScale === 0">
                                {{homework.totalCorrectQuestions}}/{{homework.totalQuestions}}
                              </a>
                              <a v-else-if="homework.gradingScale === 1">
                                {{homework.bandScore}}
                              </a>
                              <a v-else-if="homework.gradingScale === 2">
                                {{homework.hundredScore}}/100
                              </a>
                              <a v-else-if="homework.gradingScale === 4">
                                {{parseFloat(homework.totalCorrectQuestions/homework.totalQuestions).toFixed(2)}}
                              </a>
                            </div>
                          </template>
                          <div>
                            {{GRADING_SCALE[homework.gradingScale]}}
                          </div>
                        </v-tooltip>
                        </div>
                        <span v-else style="color: #EB5501; font-weight: bold; margin-left: 10px; cursor: pointer" @click="handleRedirectHomeworkDetail(homework)">{{homework.status}}</span>
                      </div>
                      <div v-if="practice.homeworks.length > 3" class="d-flex justify-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ attrs, on}">
                            <img v-on="on" v-bind="attrs" src="../../../modules/student_detail_bt/assets/more-icon.svg" @click="handleShowMoreHomeworks(practice.homeworks, practice.name, true)" alt="" style="cursor: pointer">
                          </template>
                          <div>Xem thêm bài tập</div>
                        </v-tooltip>
                      </div>
                    </div>
                    <div v-else class="d-flex align-center" style="height: 100%">
                      <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
                    </div>
                  </td>
                  <td style="width: 230px; min-width: 230px">
                    <div v-if="practice.homeworks && practice.homeworks.length > 0">
                      <div v-if="practice.homeworks.length > 1">
                        <span>
                        </span>
                        <br style=" margin-bottom: 7px">
                      </div>
                      <div v-for="(homework, index) in practice.homeworks" :key="'exercise' + index">
                        <span v-if="homework.time">{{formatDateCus(homework.time, 'DD/MM/YYYY HH:mm')}}</span>
                        <span v-else>
                          <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
                        </span>
                      </div>
                    </div>
                    <div v-else class="d-flex align-center" style="height: 100%">
                      <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
                    </div>
                  </td>
                  <td style="width: 150px; min-width: 150px">
                    <div v-if="practice.linkVideos && practice.linkVideos.length > 0">
                      <div
                        v-for="(video, index) in practice.linkVideos"
                        :key="'status' + index"
                      >
                        <a
                          v-if="video.link"
                          :href="video.link"
                          target="_blank"
                          style="text-decoration: none !important; display: flex; align-items: center"
                        >
                          <v-icon :color="VIDEO_STATUS_COLOR[video.status]">
                            mdi-video
                          </v-icon>
                          <v-tooltip top v-if="video.time">
                            <template v-slot:activator="{ attrs, on }">
                              <div v-bind="attrs" v-on="on" class="ml-1">
                                Video {{index + 1}}
                              </div>
                            </template>
                            <div>
                              Xem video: {{formatDateCus(video.time, 'DD/MM/YYYY')}}
                            </div>
                          </v-tooltip>
                          <div v-else>Video {{index + 1}}</div>
                          <br>
                        </a>
                        <div v-else class="d-flex align-center">
                          <v-icon v-if="video.status" :color="VIDEO_STATUS_COLOR[video.status]">
                            mdi-video
                          </v-icon>
                          <v-tooltip top v-if="video.time">
                            <template v-slot:activator="{ attrs, on }">
                              <div v-bind="attrs" v-on="on" class="ml-1">
                                Video {{index + 1}}
                              </div>
                            </template>
                            <div>
                              Xem video: {{formatDateCus(video.time, 'DD/MM/YYYY')}}
                            </div>
                          </v-tooltip>
                          <div v-else>Video {{index + 1}}</div>
                          <br>
                        </div>
                      </div>
                    </div>
                    <div v-else class="d-flex align-center" style="height: 100%">
                      <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
                    </div>
                  </td>
                  <td style="width: 160px; min-width: 160px">
                    <div v-if="practice.documents && practice.documents.length > 0">
                      <a v-for="(document, index) in practice.documents"
                         :key="'status' + index"
                         class="d-flex align-center"
                         target="_blank"
                         :href="document.link"
                         style="text-decoration: none !important;"
                      >
                        <v-icon style="transform: rotate(45deg)">
                          mdi-paperclip
                        </v-icon>
                        <div style="color: #0088FF">
                          Tài liệu {{index + 1}}
                        </div>
                        <br>
                      </a>
                    </div>
                    <div v-else class="d-flex align-center" style="height: 100%">
                      <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
                    </div>
                  </td>
                  <td v-if="isBlended" style="width: 350px; min-width: 350px">
                    <img src="../../../modules/student_care/assets/empty-data.svg" alt="">
                  </td>
                  <td v-if="isBlended" style="width: 100px; min-width: 100px"></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>
    <PopupShowMoreHomeworks
      :isSelfStudy="popupSelfStudy"
      :title="homeworkPopupTitle"
      :isShow="isShowHomeworkPopup"
      :homeworks="moreHomeworks"
      @redirect-homework-detail="handleRedirectHomeworkDetail"
      @close="handleCloseHomeworkPopup"></PopupShowMoreHomeworks>
    <v-dialog v-model="publishShare" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h4" style="font-weight:700">
          Chia sẻ nhận xét
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="text-center">
          Bạn có chắc chắn muốn chia sẻ nhận xét buổi học với phụ huynh học sinh ?
          <br/>
          Nhận xét sẽ được hiển thị trên web và app gia sư khi bạn xác nhận
        </v-card-text>

        <v-card-actions style="text-align: center;">
          <v-spacer></v-spacer>

          <v-btn
            class="cancel-button"
            @click="hideModal"
          >
            Hủy
          </v-btn>

          <v-btn
            class="update-button"
            @click="shareFeedbackStudent()"
          >
            Xác nhận
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isEditComment" max-width="800" persistent>
      <v-card class="quick-view">
        <v-card-title class="font-weight-bold px-5">
          Chỉnh sửa nhận xét
          <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-textarea
            v-model="newComment"
            hint="Không được để trống phần nhận xét"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-5 group-btn-comment" style="text-align: end;">
          <v-btn @click="closeModal()" class="cancel-button">
            Hủy
          </v-btn>
          <v-btn outlined color="pink" @click="saveAndShare()">
            Lưu & chia sẻ với HS
          </v-btn>
          <v-btn class="update-button" @click="saveComment()">
            Lưu
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import { IELTS_SKILL_TAG_COLOR, IELTS_TYPE, VIDEO_STATUS_COLOR } from '@/helpers/constant';
import PopupShowMoreHomeworks from '@/components/table/homework/PopupShowMoreHomeworks.vue';
import { GRADING_SCALE } from '@/modules/student_care/constant/constant';
import { mapGetters, mapActions } from 'vuex';
import StudentCareServices from '@/services/StudentCareServices';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import NoteTeacher from '@/modules/student_detail_bt/components/ModalScoreDetail/NoteTeacher.vue';

export default {
  name: 'HomeWorkTable',
  components: { PopupShowMoreHomeworks, DatePicker, NoteTeacher },
  props: {
    lmsCoreUserId: {
      type: Number,
      default: 0,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    isSelfStudy: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
      default: '',
    },
    isBlended: {
      type: Boolean,
      default: false,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      required: true,
    },
    disableFooter: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    homeworks: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      GRADING_SCALE,
      VIDEO_STATUS_COLOR,
      homeworkPopupTitle: '',
      moreHomeworks: [],
      expanded: [],
      isShowHomeworkPopup: false,
      datePicker: false,
      dataDateSelect: null,
      tableFooter: {
        // disableItemsPerPage: true,
        itemsPerPageOptions: [
          20, 50, 100, -1,
        ],
        itemsPerPageText: 'Số bản ghi trên một trang',
        itemsPerPageAllText: 'Tất cả',
      },
      tableHeaders: [
        {
          text: 'Buổi học',
          value: 'lessonTitle',
          width: 250,
          cellClass: 'font-weight-bold',
        },
        {
          text: 'Lớp/thời gian học',
          value: 'timeDate',
          width: 150,
        },
        {
          text: 'Bài tập',
          value: 'exercise',
          cellClass: 'vertical-align-top',
          width: 230,
        },
        {
          text: 'Thời gian làm bài',
          value: 'timeDoHomework',
          cellClass: 'vertical-align-top',
          width: 230,
        },
        {
          text: 'Video',
          value: 'videos',
          width: 150,
        },
        {
          text: 'Tài liệu',
          value: 'documents',
          width: 160,
        },
      ],
      tableHeadersStart: [],
      lang: {
        formatLocale: {
          monthsShort: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
        },
      },
      publishShare: false,
      shareId: null,
      isEditComment: false,
      newComment: '',
      itemReview: null,
      popupSelfStudy: false,
    };
  },
  created() {
    const currentMonth = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
    this.dataDateSelect = currentMonth;
    this.tableHeadersStart = _.cloneDeep(this.tableHeaders);
    if (this.isSelfStudy) {
      this.tableHeaders = [
        {
          text: 'Ngày học',
          value: 'date',
          width: 150,
        },
        {
          text: 'Bài học',
          value: 'name',
          width: 250,
          cellClass: 'font-weight-bold',
        },
        {
          text: 'Bài tập',
          value: 'exercise',
          cellClass: 'vertical-align-top',
          width: 230,
        },
        {
          text: 'Video',
          value: 'videos',
          width: 150,
        },
        {
          text: 'Tài liệu',
          value: 'documents',
          width: 160,
        },
      ];
    }
    if (this.headerClass) {
      this.tableHeaders = this.tableHeaders.map((e) => ({
        ...e,
        class: this.headerClass,
      }));
    }
    if (this.isBlended) {
      this.tableHeaders = this.tableHeaders.map((e) => ({
        ...e,
        cellClass: `blended ${e.cellClass}`,
        class: `blended ${this.headerClass}`,
      }));
      if (this.isPreview) {
        this.tableHeaders.unshift({
          text: this.isSelfStudy ? 'Khóa học' : 'Chương trình',
          value: 'curriculum',
          width: 150,
          cellClass: 'font-weight-bold curriculum-cell blended',
          class: `blended ${this.headerClass}`,
        });
      }
      if (!this.isSelfStudy) {
        this.tableHeaders.push(...[
          {
            text: 'Nhận xét',
            value: 'comment',
            width: 350,
            cellClass: 'blended',
            class: `blended ${this.headerClass}`,
          },
          {
            text: 'Thao tác',
            value: 'action',
            width: 100,
            cellClass: 'blended',
            class: `blended ${this.headerClass}`,
          },
        ]);
      }
    }
  },
  methods: {
    ...mapActions('student_care', ['sendComment']),
    async handleRedirectHomeworkDetail(homework) {
      const loading = this.$loading.show();
      const params = {
        lms_core_user_id: this.lmsCoreUserId,
        is_result: 1,
        type: homework.type || '',
        instance_id: homework.id,
      };
      if (this.isSelfStudy) {
        params.instance_id = homework.instanceId;
        if (homework.moduleId === 10) {
          params.type = 'revise';
        } else if (homework.moduleId === 11) {
          params.type = 'practice';
        }
      }
      const result = await StudentCareServices.getCareHomeworkReference(params);
      if (result && result.message === 'Success') {
        window.open(result.data.link, '_blank');
      }
      loading.hide();
    },
    async handleRedirectCareHomework(date, item) {
      this.$emit('redirect-care-homework', date, item);
    },
    checkPublishStatus(item) {
      if (!item.class_code) return false;
      if (item.class_code.includes('TA') && item.isTest === 2 && item.skill.length && !['', '0/0', 'null/null'].includes(item.skill[0].score.trim())) return true;
      if (item.publishStatus) return true;
      return false;
    },
    handleCloseHomeworkPopup() {
      this.isShowHomeworkPopup = false;
    },
    handleShowMoreHomeworks(homeworks, title, popupSelfStudy = false) {
      this.popupSelfStudy = popupSelfStudy;
      this.homeworkPopupTitle = title;
      this.moreHomeworks = _.cloneDeep(homeworks);
      this.isShowHomeworkPopup = true;
    },
    getSkillTagColor(skill) {
      return IELTS_SKILL_TAG_COLOR.find((e) => e.name === skill) || { color: '#000000', textColor: '#ffffff' };
    },
    getTypeTagColor(type) {
      return IELTS_TYPE.find((e) => e.name === type) || { color: '#000000', textColor: '#ffffff' };
    },
    checkHomeworksStatus(homeworks) {
      if (!homeworks) return '#eda42c';
      let color = 'grey';
      if (homeworks.filter((e) => ['Đang làm', 'Chưa làm'].includes(e.status)).length > 0 && homeworks.filter((e) => ['Đang làm', 'Chưa làm'].includes(e.status)).length < homeworks.length) color = '#eda42c';
      else if (homeworks.filter((e) => e.status === 'Đã làm').length === homeworks.length) color = '#39b258';
      return color;
      // return homeworks.some((e) => e.status === 'Chưa làm') ? '#eda42c' : '#39b258';
    },
    setDateFilter(val) {
      this.$emit('set-date-filter', val);
      this.datePicker = false;
    },
    disabledAfterToday(date) {
      return date > new Date();
    },
    publishShareAction(item) {
      this.publishShare = true;
      this.shareId = item;
    },
    hideModal() {
      this.publishShare = false;
      this.shareId = null;
    },
    async shareFeedbackStudent() {
      const loading = this.$loading.show();
      const params = {
        obj: 'comment',
        data: {
          comment_content: this.shareId.comment.join('. '),
          publish_status: 1,
        },
        filters: {
          $in__id: this.shareId.comment_ids,
        },
      };
      const res = await BlendedCareRepository.apiUpdateComment(params);
      if (res && res.message === 'Success') {
        this.shareId.publishStatus = 1;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res.message ?? 'Có lỗi xảy ra khi thực hiện thao tác!',
        });
      }
      loading.hide();
      this.hideModal();
    },
    EditAction(item) {
      this.isEditComment = true;
      this.newComment = item.comment && item.comment.length ? item.comment[0] : '';
      this.itemReview = item.comment_ids && item.comment_ids.length ? { id: item.comment_ids[0] } : null;
      this.shareId = item;
    },
    saveAndShare() {
      if (this.newComment === '') {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không được để trống phần nhận xét!',
        });
        return;
      }
      if (!this.itemReview?.id) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không tìm thấy bản ghi nhận xét, vui lòng thử lại!',
        });
        return;
      }
      this.saveComment();
      this.shareFeedbackStudent();
    },
    closeModal() {
      this.isEditComment = false;
      this.newComment = '';
      this.itemReview = null;
      this.shareId = null;
    },
    async saveComment() {
      if (this.newComment === '') {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không được để trống phần nhận xét!',
        });
        return;
      }
      if (!this.itemReview?.id) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không tìm thấy bản ghi nhận xét, vui lòng thử lại!',
        });
        return;
      }
      const params = {
        id: this.itemReview?.id,
        comment_content: this.newComment,
      };
      const res = await this.sendComment(params);
      if (!res) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra khi gửi nhận xét cho học sinh!',
        });
        return;
      }
      this.$swal({
        type: 'success',
        title: 'Thành công!',
        text: 'Đã lưu nhận xét!',
      });
    },
  },
  watch: {
    headerClass: {
      handler(val) {
        if (val) {
          this.tableHeaders = this.tableHeaders.map((e) => ({
            ...e,
            class: val,
          }));
        }
      },
      immediate: true,
    },
    isSelfStudy(val) {
      if (val) {
        this.tableHeaders = [
          {
            text: 'Ngày học',
            value: 'date',
            width: 150,
          },
          {
            text: 'Bài học',
            value: 'name',
            width: 250,
            cellClass: 'font-weight-bold',
          },
          {
            text: 'Bài tập',
            value: 'exercise',
            cellClass: 'vertical-align-top',
            width: 230,
          },
          {
            text: 'Video',
            value: 'videos',
            width: 150,
          },
          {
            text: 'Tài liệu',
            value: 'documents',
            width: 160,
          },
        ];
      } else {
        this.tableHeaders = this.tableHeadersStart;
      }
      if (this.isBlended) {
        this.tableHeaders = this.tableHeaders.map((e) => ({
          ...e,
          cellClass: `blended ${e.cellClass}`,
          class: `blended ${this.headerClass}`,
        }));
        if (!this.isSelfStudy) {
          this.tableHeaders.push(...[
            {
              text: 'Nhận xét',
              value: 'comment',
              width: 350,
              cellClass: 'blended',
              class: `blended ${this.headerClass}`,
            },
            {
              text: 'Thao tác',
              value: 'action',
              width: 100,
              cellClass: 'blended',
              class: `blended ${this.headerClass}`,
            },
          ]);
        }
      }
      const currentMonth = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
      this.dataDateSelect = currentMonth;
    },
  },
  computed: {
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    ...mapGetters('user', ['isTutorHomeroomTeacher', 'isTutorHomeroomTeacherSecondary']),
  },
};
</script>

<style lang="scss">
.custom-homework-footer {
  border-top: none !important;
  .v-data-footer__icons-after,.v-data-footer__icons-before {
    button {
      .v-btn__content {
        .v-icon {
          font-size: 24px;
        }
      }
      &.v-btn--disabled {
        background: rgba(0,0,0,.12);
        box-shadow: none;
      }
      background: #f5f5f5;
      height: 28px;
      min-width: 50px;
      border-radius: 5px !important;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    }
  }
  .v-data-footer__pagination {
    font-size: 16px;
    margin-right: 16px !important;
  }
  .v-data-footer__select {
    visibility: hidden;
  }
}
.inner-homework-table {
  table {
    tbody {
      tr {
        td {
          background: white !important;
        }
      }
    }
  }
}
.vertical-align-top {
  vertical-align: top;
}
.skill-tag {
  font-size: 13px;
  margin-top: 10px;
  border-radius: 8px;
  padding: 2px 8px;
  width: fit-content;
  font-weight: bold;
  color: white;
}
.homework-table {
  &.self-study {
    table {
      tbody {
        tr {
          td {
            background: white !important;
          }
        }
      }
    }
  }
  table {
    thead {
      tr {
        th {
          &.blended {
            background: #FBD9E9 !important;
          }
          &.first-table {
              background: #FBD9E9 !important;
          }
          &.second-table {
            background: #CCFFF3 !important;
          }
          &.third-table {
            background: #FBEFD9 !important;
          }
          background: #F47C7C !important;
          color: black !important;
          height: 40px !important;
          font-size: 13px !important;
        }
      }
    }
    tbody {
      tr {
        td {
          &.blended {
            background: #FFF8FB;
          }
          padding: 12px 16px !important;
          background: #FFF4F4;
        }
        td:first-child {
          &.curriculum-cell {
            padding: 12px 16px !important;
          }
          padding: 0 4px  !important;
        }
      }
    }
  }
}
.custom-date-picker {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.text-teacher {
  color: #0080F0;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.5px;
}
.text-comment {
  color: #000;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
}
.update-button {
  background-color: #CE2375 !important;
  color: white !important;
}
.cancel-button {
  background: #D2D2D2 !important;
  color: #333;
}
</style>
<style lang="scss">
.custome-date-2 {
  width: fit-content;
  .mx-input-wrapper {
    width: 24px;
    input {
      visibility: hidden;
    }
  }
}
.mx-calendar {
  width: 300px !important;
}
.mx-calendar-content {
  height: 160px !important;
  .active {
    background-color: #F87B67 !important;
  }
}
</style>
